import { getFormFieldValidations } from '@avalara/bat-apps-shared/lib/form-validation';
import React from 'react';
export const zuoraRegions = {
    CA: [
        'Alberta',
        'British Columbia',
        'Manitoba',
        'New Brunswick',
        'Newfoundland and Labrador',
        'Northwest Territories',
        'Nova Scotia',
        'Nunavut',
        'Ontario',
        'Prince Edward Island',
        'Quebec',
        'Saskatchewan',
        'Yukon',
    ],
    US: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'Armed Forces America',
        'Armed Forces Pacific',
        'Armed Forces',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Guam',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Puerto Rico',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virgin Islands',
        'Virginia',
        'Washington DC',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming',
    ],
};
export const convertCountryNameToCode = (countries, country) => {
    if (country === 'United States')
        return 'US';
    const matchingHardCodedCountry = countries.find(c => c.name === country);
    return matchingHardCodedCountry ? matchingHardCodedCountry.code : country;
};
export const validatePhone = (phoneNumber) => {
    const pattern = getFormFieldValidations(null).phone;
    return new RegExp(pattern).test(phoneNumber.trim().replace(/\s/, ''));
};
export const getValidationMessage = (validationError, _, displayName) => {
    if (validationError === 'isInvalid') {
        return displayName === 'phone number'
            ? React.createElement("em", null, "Invalid phone number")
            : React.createElement("em", null, `This doesn't appear to be a valid ${displayName}`);
    }
    if (validationError === 'isRequired') {
        const vowels = ['a', 'e', 'i', 'o', 'u'];
        const article = vowels.includes(displayName.charAt(0)) ? 'An' : 'A';
        return React.createElement("em", { className: 'error contact-validation-error' }, `${article} ${displayName} is required`);
    }
    return null;
};
